import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "../item.css";

export const DateFieldItemForm = ({ field, changeValueCallback, itemForm, isDisabled }) => {
    const [t, i18n] = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;

    const handleInputChange = (value) => {
        const isValid = value && dayjs(value).isValid();
        const isoValue = isValid ? dayjs(value).startOf('day').toISOString() : null;
        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: isoValue
            }
        });
    }

    return (
        <div className={`datetime-picker ${isDisabled ? "" : "enabled"}`}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    sx={{ marginTop: "7px" }}
                    format="DD/MM/YYYY"
                    slotProps={{ textField: { size: 'small', InputLabelProps: { shrink: true }, fullWidth: true } }}
                    label={field.Captions[currentLanguage]?.length > 0 ? `${field.Captions[currentLanguage]}${field.IsMandatory ? '*' : ''}` : `${field.Code}${field.IsMandatory ? '*' : ''}`}
                    value={itemForm.form[field.Code] ? dayjs(itemForm.form[field.Code]) : null}
                    onChange={(e) => handleInputChange(e)}
                    disabled={isDisabled}
                />
            </LocalizationProvider>
        </div>
    )
}
